import React, { useState, useEffect } from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { MessageOutlined } from "@ant-design/icons";
import LinkedPostView from "./LinkedinPostView";
import styles from "./styles/linkedin.module.css";
import { useCurrentUser } from "../actions/auth";

export default function Linkedin_posts() {
    const {
        isLoading: loadingMe,
        isSuccess: successMe,
        data: dataMe,
    } = useCurrentUser();
    // Mock data - replace with your actual API data

    const [post, setPost] = useState({
        author: "Jane Doe",
        authorTitle: "Marketing Director at XYZ Company",
        authorImage: "https://randomuser.me/api/portraits/women/12.jpg",
        postDate: "2d ago",
        text: "Excited to announce our new product launch! After months of hard work, our team has created something truly innovative that will transform how businesses operate. #innovation #newproduct #exciting",
        image: "https://images.unsplash.com/photo-1661956602116-aa6865609028?ixlib=rb-4.0.3",
        likes: 142,
        comments: 23,
        shares: 7,
    });
    console.log("data", dataMe);
    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="LinkedIn Posts"
                    icon={<MessageOutlined />}
                ></SectionHeader>
            }
        >
            <LinkedPostView />
            {/* <div className={styles.linkedinContainer}>
                <div className={styles.linkedinPost}>
                    <div className={styles.postHeader}>
                        <img
                            src={dataMe.avatar || post.authorImage}
                            alt="Profile"
                            className={styles.profileImage}
                        />
                        <div className={styles.userInfo}>
                            <h3 className={styles.userName}>
                                {dataMe.first_name} {dataMe.last_name}
                            </h3>
                            <p className={styles.userHeadline}>
                                {dataMe.email}
                            </p>
                            <span className={styles.postDate}>
                                {post.postDate}
                            </span>
                        </div>
                    </div>
                    <div className={styles.postContent}>
                        <p className={styles.postText}>{post.text}</p>
                        {post.image && (
                            <img
                                src={post.image}
                                alt="Post attachment"
                                className={styles.postImage}
                            />
                        )}
                    </div>
                </div>
            </div> */}
        </QurealSection>
    );
}
